import WhDocument from "../services/wh-document.service";
import ApiService from "../services/api.service"
import {TokenService} from "../services/storage.service"
import Vue from 'vue'

const state = {
	customIndexStore: 0,
	depSaleType: null,
	itemsForWhGrid: [],
	notExFoundItemsFrom: [],
	notFoundItemsFrom:[],
	requestItems: null,
	editRequest: false,
	customDepartments: {},
	pageStore: 1,
	fields: [
		{key: 'itemId', label: 'ПунктId', visible: true, 'class': 'min-60', sortable: true, changebale: true},
		{key: 'documentId', label: 'Документ Id', 'class': 'min-80', visible: true, sortable: true, changebale: true},
		{key: 'regNumber', label: 'Документ номер', visible: true, 'class': 'min-80', sortable: true, changebale: true},
		{key: 'barcode', label: 'Спец-код', visible: true, 'class': 'min-80', sortable: true, changebale: true},
		{key: 'itemName', label: 'Название предмета', 'class': 'min-80', visible: true, sortable: true, changebale: true},
		{key: 'artikul', label: 'Артикул', 'class': 'min-80', sortable: true, changebale: true},
		{key: 'remaining', label: 'Кол-во', 'class': 'min-60', sortable: true, changebale: true},
		{key: 'incomeUzs', label: 'Приходная цена', visible: true, 'class': 'min-80', sortable: true, changebale: true},
		{key: 'docRegDate',	label: 'Дата регистрации',class: 'min-80',visible: true,sortable: true,	changebale: true},
		{key: 'termOfItem',label: 'Срок годности','class': 'min-40 ',	visible: true,	changebale: false},
		{key: 'docItemCount',label: 'Кол-во приход','class': 'min-40 ',	visible: true,	changebale: false},
	],
	columns: {
		income: [
			{key: 'actions',label: 'incomes.actions','class': 'min-60',visible: true,changebale: false},
			{key: 'id',label: 'ID',	sortable: true,	visible: true,'class': 'min-60 text-center',changebale: false},
			{key: 'regDate',label: 'incomes.date',visible: true,'class': 'min-80',	sortable: true,	changebale: true},
			{key: 'documentStatus',	label: 'promo-to-product.status',visible: true,	'class': 'min-100',	sortable: true,	changebale: true},
			{key: 'regNumber',label: 'incomes.name',visible: true,'class': 'min-200',sortable: true,changebale: true},
			{key: 'docCreatedBy',label: 'Создатель',visible: false,	'class': 'min-200',	sortable: true,	changebale: true},
			{key: 'docCreatedDate',	label: 'Дата создания',	visible: false,	'class': 'min-200',	sortable: true,	changebale: true},
			{key: 'docLastModifiedBy',label: 'Обнoвлён',visible: false,	'class': 'min-200',	sortable: true,	changebale: true},
			{key: 'docChangedDate',	label: 'Дата обновления',visible: false,'class': 'min-200',	sortable: true,	changebale: true},
			{key: 'contragentName',	label: 'incomes.counteragent',visible: true,'class': 'min-150',	sortable: true,	changebale: true},
			{key: 'reason',	label: 'Сч/фактура поставщика',	visible: true,sortable: true,'class': 'min-200',changebale: true},
			{key: 'numberGTD',	label: 'Номер ГТД',	visible: true,sortable: true,'class': 'min-200',changebale: true},
			{key: 'extraCosts',label: 'sidebar.warehouse-management.extra-cost',class: 'min-150',visible: true,	sortable: true,	changebale: true},
			{key: 'toDepartmentName',label: 'incomes.department',visible: false,sortable: true,	class: 'min-150',changebale: true},
			{key: 'comment',label: 'comment','class': 'min-200',visible: true,sortable: true,changebale: true},
			{key: 'responsibleName',label: 'incomes.responsible',visible: false,sortable: true,	changebale: true},
			{key: 'fromEmployeeName',label: 'incomes.from-employee',visible: false,'class': 'min-150',sortable: true,changebale: true},
			{key: 'toEmployeeName',	label: 'incomes.to-employee',visible: false,'class': 'min-150',sortable: true,changebale: true}
		],
		pendingIncomesFields: [
			{key: 'id',	label: '№', sortable: true,visible: true,'class': 'min-60',	changebale: false},
			{key: 'regDate',label: 'incomes.date',visible: true,'class': 'min-80',sortable: true,changebale: true},
			{key: 'regNumber',label: 'incomes.name',visible: true,'class': 'min-200',sortable: true,changebale: true},
			{key: 'comment',label: 'comment','class': 'min-200',visible: true,sortable: true,changebale: true},
			{key: 'fromEmployeeName',label: 'incomes.from-employee',visible: true,'class': 'min-150',sortable: true,changebale: true},
			{key: 'fromDepartmentName',	label: 'incomes.fromDepartment',class: 'min-150',visible: true,	sortable: true,	changebale: true},
			{key: 'actions',label: 'incomes.actions','class': 'table_actions min-60 fixed-col',	visible: true,changebale: false	}

		],
		outcome: [
			{key: 'id',	label: 'ID',sortable: true,	visible: true,'class': 'min-60',changebale: false},
			{key: 'regDate',label: 'incomes.date',visible: true,'class': 'min-80',sortable: true,changebale: true},
			{key: 'regNumber',	label: 'incomes.name',visible: true,'class': 'min-200',	sortable: true,	changebale: true},
			{key: 'fromDepartmentName',	label: 'incomes.department',class: 'min-150',visible: false,sortable: true,changebale: true},
			{key: 'reason',	label: 'incomes.reason',visible: true,sortable: true,'class': 'min-200',changebale: true},
			{key: 'comment',label: 'comment','class': 'min-200',visible: true,sortable: true,changebale: true},
			{key: 'responsibleName',label: 'incomes.responsible',visible: false,sortable: true,	changebale: true},
			{key: 'fromEmployeeName',label: 'incomes.from-employee',visible: false,'class': 'min-150',		sortable: true,	changebale: true},
			{key: 'toEmployeeName',	label: 'incomes.to-employee',visible: false,'class': 'min-150',	sortable: true,	changebale: true},
			/*{key: 'contragentName',label: 'incomes.counteragent',	visible: false,	'class': 'min-150',	sortable: true,	changebale: true},*/
			{key: 'actions',label: 'incomes.actions','class': 'table_actions min-60 fixed-col',	visible: true,changebale: false}

		],
		transfer: [
			{key: 'actions',label: 'incomes.actions','class': 'min-60',	visible: true,changebale: false},
			{key: 'id',label: 'ID',sortable: true,visible: true,'class': 'min-60 text-center',changebale: false},
			{key: 'regDate',label: 'incomes.date',visible: true,'class': 'min-80',sortable: true,changebale: true},
			{key: 'regNumber',label: 'incomes.name',visible: true,'class': 'min-180',sortable: true,	changebale: true},
			{key: 'docCreatedBy',label: 'Создатель',visible: true,	'class': 'min-180',sortable: true,changebale: true},
			{key: 'docCreatedDate',label: 'Дата создания',visible: true,'class': 'text-center',sortable: true,	changebale: true},
			{key: 'docLastModifiedBy',label: 'Обнoвлён',visible: true,'class': 'min-180',sortable: true,changebale: true},
			{key: 'docChangedDate',	label: 'Дата обновления',visible: true,'class': 'text-center',sortable: true,changebale: true},
			{key: 'extraCosts',	label: 'sidebar.warehouse-management.extra-cost',class: 'min-150',visible: false,sortable: true,changebale: true},
			{key: 'fromDepartmentName',label: 'incomes.fromDepartment',class: 'min-130',visible: true,sortable: true,changebale: true},
			{key: 'toDepartmentName',label: 'incomes.toDepartment',	class: 'min-130',visible: true,sortable: true,changebale: true},
			{key: 'reason',	label: 'incomes.reason',visible: true,sortable: true,'class': 'min-200',changebale: true},
			{key: 'comment',label: 'comment','class': 'min-200',visible: false,	sortable: true,changebale: true},
			{key: 'responsibleName',label: 'incomes.responsible',visible: false,sortable: true,changebale: true},
			{key: 'fromEmployeeName',label: 'incomes.from-employee',visible: false,	'class': 'min-150',	sortable: true,changebale: true},
			{key: 'toEmployeeName',	label: 'incomes.to-employee',visible: false,'class': 'min-150',sortable: true,changebale: true}
		],
		writeOff: [
			{key: 'actions',label: 'incomes.actions','class': 'min-60',visible: true,changebale: false},
			{key: 'id',	label: 'ID',sortable: true,visible: true,'class': 'min-60 text-center',	changebale: false},
			{key: 'regDate',label: 'incomes.date',visible: true,'class': 'min-80',sortable: true,changebale: true},
			{key: 'regNumber',label: 'incomes.name',visible: true,'class': 'min-200',sortable: true,changebale: true},
			{key: 'docCreatedBy',label: 'Создатель',visible: false,'class': 'min-200',sortable: true,changebale: true},
			{key: 'docCreatedDate',	label: 'Дата создания',	visible: false,'class': 'text-center',sortable: true,changebale: true},
			{key: 'docLastModifiedBy',label: 'Обнoвлён',visible: false,'class': 'min-200',sortable: true,changebale: true},
			{key: 'docChangedDate',	label: 'Дата обновления',visible: false,'class': 'text-center',	sortable: true,	changebale: true},
			{key: 'fromDepartmentName',	label: 'incomes.department',class: 'min-150',visible: true,	sortable: true,	changebale: true},
			{key: 'reason',	label: 'incomes.reason',visible: true,sortable: true,'class': 'min-200',changebale: true},
			{key: 'comment',label: 'comment','class': 'min-200',visible: true,sortable: true,changebale: true},
			{key: 'responsibleName',label: 'incomes.responsible',visible: false,sortable: true,	changebale: true}
		],
	},
	warehouses: ['WAREHOUSE', 'DINING_ROOM', 'SHOP', 'COMPANY'],
	returnPending: null,
	loading: false,
	itemsForModal: [],
	sectors: [],
	pricingItem: null,
	pricingItems: [],
	priceUzs: null,
	priceWholesale: null,
	incomePriceUzs: null,
	priceIsNotDifferent: true,
	balance: 0,
	currentItemBalanceError: false,
	currentPricingItemError: false,
	whDocSaveDisabled: false,
	filteredItems: [],
	itemBalance: [],
	itemsForItemConvert: [],
	viewforModalItems: [],
	itemsNotKirim: [],
	fromIncomeToTransfer: {
		status: false,
		allItems: [],
		notPossibleItems: [],
		toDepartment: null,
		fromDepartment: null,
		currency: null,
	},
	currentWhItems: [],
	priceWhItems: [],
	pendingIncomePackages: [],
	packListItems: [],
	totalPendingPackages: 0,
	receivedResponse: null,
	acceptedResponse: null,
	newDocument: {
		id: null,
		comment: null,
		action: 'KIRIM',
		documentType: 'NAKLADNOY',
		fromDepartmentId: null,
		fromDepartmentName: null,
		toDepartmentId: localStorage.getItem('dep_id'),
		toDepartmentName: null,
		fromEmployeeId: null,
		fromEmployeeName: null,
		toEmployeeId: null,
		toEmployeeName: '',
		responsible1Id: null,
		responsible1Name: '',
		responsible2Id: null,
		responsible2Name: '',
		regNumber: '',
		regDate: null,
		contragentId: null,
		contragentName: '',
		reason: null,
		initiatorId: null,
		fromCurrencyRate: null,
		currencyId: null,
		toCurrencyRate: null,
		whItems: []
	},
	currentPackDocId: null,
	pendingPacksCount: 0,
	foundItemsFromXls: [],
	notFoundItemsFromXls: [],
};
const getters = {
	columnsIncome: (state) => {
		return state.columns.income
	},
	columnsPendingIncomes: (state) => {
		return state.columns.pendingIncomesFields
	},
	columnsOutcome: (state) => {
		return state.columns.outcome
	},
	columnsTransfer: (state) => {
		return state.columns.transfer;
	},
	columnsOff: (state) => {
		return state.columns.writeOff;
	},
	wTypes: (state) => {
		return state.warehouses;
	}

};
const actions = {
	async getItemsForDepBySaleType({commit}, payload) {
		try {
			let response = {};
			if (payload.depSaleType == 'RETAIL') {
				response = await WhDocument.getItemsForDepBySaleTypeRetail(payload);
			} else {
				response = await WhDocument.getItemsForDepBySaleTypeWhole(payload);
			}
			await commit('setListByProductsNotKirim', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	async getItemsForDepBySaleTypeTransfer({commit}, payload) {
		try {
			let response = {};
			if (payload.depSaleType == 'RETAIL') {
				response = await WhDocument.getItemsForDepBySaleTypeRetailTransfer(payload);
			} else {
				response = await WhDocument.getItemsForDepBySaleTypeWhole(payload);
			}
			await commit('setListByProductsNotKirim', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	async getItemsForDepBySaleTypeOff({commit}, payload) {
		try {
			let response = {};
			if (payload.depSaleType == 'RETAIL') {
				response = await WhDocument.getItemsForDepBySaleTypeRetailOff(payload);
			} else {
				response = await WhDocument.getItemsForDepBySaleTypeWholeOff(payload);
			}
			await commit('setListByProductsNotKirim', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	async getItemsListForWhGrid({commit}, data) {
		try {
			commit('setLoading', true);
			const response = await WhDocument.getItemsListForWhGrid(data);
			commit('setItemsForWhGrid', response);
			return true
		} catch (e) {
			commit('setLoading', false);
			return false
		}
	},
	async addRowVariantToXlsItems({commit}) {
		await commit('setRowVariantForXlsItems');
	},
	async resetExcelData({commit}) {
		await commit('setExcelResponseIncome', false);
		return true;
	},
	async uploadExcelForIncome({commit}, payload) {
		try {
			let response = await WhDocument.uploadExcelForIncome(payload);
			commit('setExcelResponseIncome', response.data);
			return true;
		} catch (e) {
			commit('setExcelResponseIncome', false);
			return false;
		}
	},
	async uploadExcelForVendorIncome({commit}, payload) {
		try {
			let response = await WhDocument.uploadExcelVendorForIncome(payload);
			commit('setExcelResponseIncome', response.data);
			return true;
		} catch (e) {
			commit('setExcelResponseIncome', false);
			return false;
		}
	},
	async uploadExcelForSpisat({commit}, payload) {
		try {
			let response = await WhDocument.uploadExcelForSpisat(payload);
			commit('setExcelResponseIncome', response.data);
			return true;
		} catch (e) {
			commit('setExcelResponseIncome', false);
			return false;
		}
	},
	async uploadExcelForTransfer({commit}, payload) {
		try {
			let response = await WhDocument.uploadExcelForTransfer(payload);
			commit('setExcelResponseIncome', response.data);
			return true;
		} catch (e) {
			commit('setExcelResponseIncome', false);
			return false;
		}
	},
	async getPendingIncomesCount({commit}) {
		try {
			let payload = {
				user: "SAMO-API-USER",
				password: "samo-api-password"
			}
			let response = await WhDocument.getPendingIncomesCountService(payload);
			commit('setPendingIncomesCount', response.data);
			return true;
		} catch (e) {
			return false;
		}
	},
	async getWhDocById({commit}, docId) {
		try {
			let response = await WhDocument.get(docId);
			commit('setNewDocument', response.data);
			return true;
		} catch (e) {
			return false;
		}
	},
	async createWhDoc({commit}, payload) {
		try {
			let response = await WhDocument.store(payload);
			commit('setNewDocument', response.data);
			return true;
		} catch (e) {
			return false;
		} finally {
		}
	},
	async checkPendingIncomeItems({commit, state}, items) {
		try {
			state.newDocument.whItems = items;
			const response = await WhDocument.checkPendingIncomeItems(state.newDocument);
			commit('setCheckPendingResponse', response.data);
			// commit('setReceivedPendingIncomeError', null);
			return true
		} catch (e) {
			//let response = JSON.parse(e.request.response);
			// commit('setReceivedPendingIncomeError', response.message);
			return false
		}
	},
	async receivePendingIncome({commit, state}, items) {
		try {
			state.newDocument.whItems = items;
			const response = await WhDocument.receivePendingIncome(state.newDocument);
			commit('setReceivedPendingIncome', response.data);
			commit('setReceivedPendingIncomeError', null);
			return true
		} catch (e) {
			if (e.request) {
				let response = JSON.parse(e.request.response);
				commit('setReceivedPendingIncomeError', response.message);
			}
			commit('setReceivedPendingIncomeError', true);
			return false
		}
	},
	async acceptByManufacturer({commit, state}, payload) {
		try {
			payload.user = "SAMO-API-USER";
			payload.password = "samo-api-password";
			const response = await WhDocument.acceptByManufacturer(payload);
			commit('setAcceptedPendingIncome', response.data);
			return true
		} catch (e) {

			return false
		}
	},
	async getPendingIncomes({commit, state}) {
		try {
			let payload = {
				user: "SAMO-API-USER",
				password: "samo-api-password"
			}
			ApiService.removeHeader();
			const response = await WhDocument.getPendingIncomesFromManufactureApi(payload);
			ApiService.setHeader();
			commit('setPendingIncomesFromManufacture', response.data);
			return true
		} catch (e) {
			ApiService.setHeader();
			return false
		}
	},
	async getPackListAction({commit, state}, id) {
		try {
			let payload = {
				user: "SAMO-API-USER",
				password: "samo-api-password",
				id: id,
				doc_id: state.newDocument.id
			}
			const response = await WhDocument.getPackList(payload);
			commit('setPackList', response.data);
			return true
		} catch (e) {
			return false
		}
	},

	async returnPendingAction({commit, state}, docId) {
		try {
			const response = await WhDocument.returnPending(docId);
			commit('returnPendingMutation', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	async lastPriceByItemId({commit}, payload) {
		try {
			const response = await WhDocument.lastPriceOfItem(payload.department, payload.itemId);
			await commit('setCurrentPricingItem', response.data);
			await commit('currentPricingItemError', false)
			return true
		} catch (e) {
			commit('currentPricingItemError', true)
			return false
		}
	},
	async getListByProductsNotKirim({commit}, payload) {
		try {
			const response = await WhDocument.getListByProductsNotKirimService(payload);
			await commit('setListByProductsNotKirim', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	async loadBalance({commit}, payload) {
		try {
			const response = await WhDocument.balanceByItem(payload.department, payload.itemId);
			await commit('setCurrentItemBalance', response.data);
			await commit('currentItemBalanceError', false);
			return true
		} catch (e) {
			commit('currentItemBalanceError', true);
			return false
		}
	},
	async loadNewBalance({commit}, payload) {

		try {
			const response = await WhDocument.getBalanceItem(payload.department, payload.itemId, payload.type);
			await commit('setCurrentItemBalance', response.data.count);
			await commit('currentItemBalanceError', false);

			await commit('setCurrentPricingItem', response.data);
			if (response.data.price <= 0) {
				await commit('priceIsDifference', false);
			} else {
				await commit('priceIsDifference', response.data.status);
			}
			return true
		} catch (e) {
			commit('currentItemBalanceError', true);
			return false
		}
	},
	async getBalancePrice({commit, state}, data) {
		try {
			commit('setLoading', true);
			const response = await WhDocument.balancePrice(data);
			commit('setFilteredItems', response);
			return true
		} catch (e) {
			commit('setLoading', false);
			return false
		}
	},
	async itemBalance({commit, state}, data) {
		try {
			commit('setLoading', true);
			const response = await WhDocument.itemBalance(data);
			commit('setItemBalance', response);
			return true
		} catch (e) {
			commit('setLoading', false);
			return false
		}
	},
	async getItemsForItemConvert({commit, state}, data) {
		try {
			commit('setLoading', true);
			const response = await WhDocument.getItemsForItemConvertService(data);
			commit('setItemsForItemConvert', response);
			return true
		} catch (e) {
			commit('setLoading', false);
			return false
		}
	},
	async clearInventoryList({commit, state}, payload) {
		try {
			const response = await WhDocument.clearInventory(payload);
			commit('setClearInventoryResponse', response);
			return true
		} catch (e) {
			return false
		}
	},
	async changePriceNotDifferent({commit}, state) {
		commit('setDefaultNotDifferent', true);
	},
	async changeCurrentPackDocId({commit}, payload) {
		await commit('setCurrentPackDocId', payload)
	},
	async setFromIncomeToTransfer({commit}, payload) {
		if (payload.status) {
			commit('setDataFromIncomeToTransfer', payload)
		} else {
			commit('setDataFromIncomeToTransfer', {
				status: false,
				allItems: [],
				notPossibleItems: [],
				toDepartment: null,
				fromDepartment: null,
				currency: null,
			})
		}

	},
	async setCurrentWhItems({commit}, payload) {
		if (payload.status) {
			commit('setDataCurrentWhItems', payload.data)
		} else {
			commit('setDataCurrentWhItems', [])
		}
	},
	async setPriceWhItems({commit}, payload) {
		if (payload.status) {
			commit('setDataPriceWhItems', payload.data)
		} else {
			commit('setDataPriceWhItems', [])
		}
	},
};

const mutations = {
	setPageStore(state, page) {
		state.pageStore = page
	},
	setTabCustomIndex(state, index) {
		state.customIndexStore = index
	},
	setDepSaleTypeForDoc(state, depSaleTypePayload) {
		state.depSaleType = depSaleTypePayload;
	},
	setItemsForWhGrid(state, payload) {
		state.itemsForWhGrid = payload;
		state.loading = false;
	},
	setRequestItems(state, paylaod) {
		state.requestItems = paylaod.data
		state.editRequest = paylaod.edit
	},
	setDataCurrentWhItems(state, res) {
		state.currentWhItems = res;
	},
	setDataPriceWhItems(state, res) {
		state.priceWhItems = res;
	},

	setViewRequestWarehouseModalItems(state, res) {
		state.viewforModalItems = res;
	},
	setDataFromIncomeToTransfer(state, data) {
		state.fromIncomeToTransfer = data
	},
	setRowVariantForXlsItems(state) {
		state.foundItemsFromXls.forEach(el => {
			Vue.set(el, "_rowVariant", "success");
		})
	},
	setExcelResponseIncome(state, res) {
		if (res) {
			state.foundItemsFromXls = res.warehouseDocument.whItems;
			state.notFoundItemsFromXls = res.notFoundItems;
		} else {
			state.foundItemsFromXls = [];
			state.notFoundItemsFromXls = [];
		}
	},
	setCheckPendingResponse(state, res) {
		state.newDocument = res;
		res.whItems.forEach((el, index) => {
			if (state.packListItems[index].id == el.id) {
				Vue.set(state.packListItems[index], "_rowVariant", el["_rowVariant"]);
				// state.packListItems[index] = el;
			}
		})
	},
	setPendingIncomesCount(state, payload) {
		state.pendingPacksCount = payload.total;
	},
	setCurrentPackDocId(state, payload) {
		state.currentPackDocId = payload;
	},
	setReceivedPendingIncome(state, res) {
		state.receivedResponse = res;
	},
	setReceivedPendingIncomeError(state, res) {
		state.receiveErrorMsg = res;
	},
	setAcceptedPendingIncome(state, res) {
		state.acceptedResponse = res;
	},
	setNewDocument(state, res) {
		state.newDocument = res;
	},
	setPendingIncomesFromManufacture(state, res) {
		state.pendingIncomePackages = res.data;
		state.totalPendingPackages = res.total;
	},
	setPackList(state, res) {
		state.packListItems = res.data;
	},
	// setViewRequestWarehouseModalItems(state,res){
	// 	state.viewforModalItems = res;
	// },
	deleteFromItems(state, index) {
		state.itemsForModal.splice(index, 1)
	},
	setItemsForModal(state, items) {
		state.itemsForModal = items;
		state.itemsForModal.forEach(el => {
			el.comment = ''
		})
	},
	setWarehousePricingItems(state, items) {
		state.pricingItems = items
	},
	setItemsForExeption(state, items) {
		items.forEach(el => {
			if (state.itemsForModal.indexOf(el) == -1) {
				el.comment = ''
				state.itemsForModal.push(el)
			} else {
			}
		})

	},
	deleteItemsForExeption(state, items) {
		items.forEach(el => {
			el.comment = ''
			if (state.itemsForModal.indexOf(el) != -1) {
				state.itemsForModal.splice(state.itemsForModal.indexOf(el), 1)
			} else {
			}
		})
	},
	setListByProductsNotKirim(state, res) {
		state.itemsNotKirim = res;
	},
	setFromDepartmentId(state, departments) {
		state.customDepartments = departments;
	},
	returnPendingMutation(state, response) {
		state.returnPending = response;
	},
	setLoading(state, payload) {
		state.loading = payload
	},
	setCurrentPricingItem(state, response) {
		state.pricingItem = response
	},
	priceIsDifference(state, response) {
		state.priceIsNotDifferent = response
	},
	setDefaultNotDifferent(state) {
		state.priceIsNotDifferent = true
	},
	currentPricingItemError(state, boolean) {
		state.currentPricingItemError = boolean
	},
	setCurrentItemBalance(state, response) {
		state.balance = response
	},
	currentItemBalanceError(state, boolean) {
		state.currentItemBalanceError = boolean
	},
	resetCurrentItemBalance(state) {
		state.balance = 0
	},
	setClearInventoryResponse(state, response) {
	},
	setWhDocDisabled(state, boolean) {
		state.whDocSaveDisabled = boolean;
	},
	setFilteredItems(state, payload) {
		state.filteredItems = payload
		state.loading = false
	},
	setItemBalance(state, payload) {
		// state.filteredItems = payload
		state.itemBalance = payload
		state.loading = false
	},
	setItemsForItemConvert(state, payload) {
		state.itemsForItemConvert = payload
		state.loading = false
	},
	setWrappedItemsForConvert(state, payload) {
		let index = Object.values(state.itemsForItemConvert)[0].indexOf(payload.item)
		Vue.set(Object.values(state.itemsForItemConvert)[0][index], "wrappedItems", payload.wrappedItems)
		Object.values(state.itemsForItemConvert)[0][index].hasItems = payload.hasItems


	},
	setSector(state, sectors) {
		state.sectors = sectors;
	},
	clearNotFoundItemsFromXls(state){
		state.notFoundItemsFromXls = []
	}
};
export const warehouse = {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
